import './index.scss';

import React from 'react';

import { getLeftArrowImage } from '../../utils/imageChanges';

const MobileHeaderWithoutSearch = props => {
  const {  goBackClick, headerTitle, theme } = props;
  return (
    <div className="header-title">
      <div className="header-title__left">
        <div
          className="header-title__arrow"
          role="presentation"
          onClick={() => goBackClick()}
        >
          <img src={getLeftArrowImage(theme)} alt="left arrow" />
        </div>
        <div className="header-title__name">{headerTitle}</div>
      </div>
    </div>
  );
};

export default MobileHeaderWithoutSearch;
